export default __webpack_public_path__ + "static/media/icon-sidebar-redeem.13c62351.svg";